import { useQuery } from '@tanstack/react-query';
import { api } from './client';
import { McpAuditLogItem, PaginatedResponse } from './types';

/**
 * TanStack Query hook to fetch MCP & API activity audit logs from GET /api/v2/mcp-logs/
 */
export function useMcpAuditLogs(page = 1, pageSize = 10) {
  return useQuery<PaginatedResponse<McpAuditLogItem>>({
    queryKey: ['mcp-logs', page, pageSize],
    queryFn: async () => {
      const res = await api.get<PaginatedResponse<McpAuditLogItem> | McpAuditLogItem[]>('/v2/mcp-logs/', {
        params: { page, page_size: pageSize },
      });

      if (Array.isArray(res.data)) {
        return {
          results: res.data,
          pagination: {
            page: 1,
            page_size: res.data.length,
            total: res.data.length,
            has_next: false,
          },
        };
      }

      return res.data;
    },
    retry: false, // Don't spam retries if endpoint is under maintenance
    staleTime: 15 * 1000,
  });
}
